import { triggerSimpleAjax } from '../../helpers/httpHelper';
import {  GET_OUTLETS_ACTIONS } from '../../helpers/constants/apiUrl';

export default function getOutletActions(outlet_id) {
    const url = outlet_id ? `${GET_OUTLETS_ACTIONS}?outlet_id=${outlet_id}` : `${GET_OUTLETS_ACTIONS}`;
    return new Promise((res, rej) => {
        triggerSimpleAjax(
            url,
            'GET',
            {},
            (response) => {
                res(response);
            },
            error => {
                rej(error);
            }
        );
    });
}